import { unref as c } from "vue";
function m(e, n = {}) {
  const { timeout: r = 500, scroll: l = { behavior: "smooth", block: "end" } } = n, t = c(e), o = t.$el ?? t;
  setTimeout(
    () => o == null ? void 0 : o.scrollIntoView(l),
    // Give all children of componentOrElementRef time to compute
    // their dimensions, and time for the user to see the UI
    // stabilise before we scroll. This value is totally arbitrary.
    r
  );
}
export {
  m as scrollToElement
};
